import axios from 'axios';
import { useToken } from '../store/auth/tokenStore';


// Redireciona todas as chamadas para o proxy do Worker
const finalBaseURL = import.meta.env.VITE_API_URL + '/api'

export const axiosClient = axios.create({
    baseURL: finalBaseURL,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    },
});

axiosClient.interceptors.request.use((request) => {
    const token = useToken.getState().token
    if(!token) return request
    request.headers["Authorization"] = `Bearer ${token}`
    return request
})

// axiosClient.interceptors.response.use(response => {
//     const token = response.headers['x-access-token'];
//     if (token) {
//         useToken.getState().setToken(token);
//     }
//     return response;
// });
